<form #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate>

  <div class="modal-header">
    <h5 class="modal-title">
      {{title}}
      <span *ngIf="itemToSave.client_nom" class="ms-2 opacity-75" style="font-size:0.85em;font-weight:400;">
        — {{ itemToSave.client_nom }} {{ itemToSave.client_prenom }}
      </span>
    </h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Fermer"></button>
  </div>
  <div class="modal-body">

    <!-- Ligne 1 : Synthèse (lecture seule) -->
    <div class="row g-3 mb-3 p-2 bg-light rounded">
      <div class="col-md-3">
        <label for="montant_total" class="form-label fw-semibold">Montant total</label>
        <input disabled id="montant_total" name="montant_total" [ngModel]="itemToSave.montant_total | IntegerFormatPipe"
          type="text" class="form-control" />
      </div>
      <div class="col-md-3">
        <label for="total_regle" class="form-label fw-semibold">Déjà réglé</label>
        <input disabled id="total_regle" name="total_regle" [ngModel]="itemToSave.total_regle | IntegerFormatPipe"
          type="text" class="form-control" />
      </div>
      <div class="col-md-3">
        <label for="total_remise" class="form-label fw-semibold">Remise</label>
        <input disabled id="total_remise" name="total_remise" [ngModel]="itemToSave.total_remise | IntegerFormatPipe"
          type="text" class="form-control" />
      </div>
      <div class="col-md-3">
        <label for="reste_a_regler" class="form-label fw-semibold">Reste à régler</label>
        <input disabled id="reste_a_regler" name="reste_a_regler"
          [ngModel]="itemToSave.reste_a_regler | IntegerFormatPipe" type="text" class="form-control" />
      </div>
    </div>

    <!-- Ligne 2 : Saisie règlement -->
    <div class="row g-3 mb-3">
      <div class="col-md-2">
        <label class="form-label">Mode règlement</label>
        <select class="form-select" name="mode_reglement_id" [(ngModel)]="itemToSave.mode_reglement_id" required
          #mode_reglement_idCtrl="ngModel">
          <option value="" disabled selected>--</option>
          <option *ngFor="let item of itemsModeReglement" [value]="item.id"
            [disabled]="item.codification === 'FIDELITY' && !canUseFidelity()">
            {{item.libelle}}
            <ng-container *ngIf="item.codification === 'FIDELITY' && clientFidelite">
              ({{ clientFidelite.montant_equivalent ?? 0 }} disponible)
            </ng-container>
          </option>
        </select>
        <div class="text-danger small mt-1" *ngIf="mode_reglement_idCtrl.invalid && mode_reglement_idCtrl.touched">
          Requis</div>
        <div class="text-info small mt-1" *ngIf="isFidelitySelected() && clientFidelite">
          Solde fidélité : {{ clientFidelite.montant_equivalent ?? 0 | IntegerFormatPipe }}
        </div>
        <div class="text-warning small mt-1"
          *ngIf="isFidelitySelected() && clientFidelite && clientFidelite.montant_equivalent < (itemToSave.montant ?? 0)">
          Points insuffisants
        </div>
      </div>
      <div class="col-md-2">
        <label class="form-label">Caisse</label>
        <select class="form-select" name="caisse_id" [(ngModel)]="itemToSave.caisse_id" required
          #caisse_idCtrl="ngModel">
          <option value="" disabled selected>--</option>
          <option *ngFor="let item of itemsUserCaisse" [value]="item.caisse_id">{{item.caisse_libelle}}</option>
        </select>
        <div class="text-danger small mt-1" *ngIf="caisse_idCtrl.invalid && caisse_idCtrl.touched">Requis</div>
      </div>
      <div class="col-md-2">
        <label class="form-label">Montant réglé</label>
        <input (input)="onCalculateMonnaie()" class="form-control" name="montant" [(ngModel)]="itemToSave.montant"
          #montantCtrl="ngModel" type="number" required [max]="itemToSave.reste_a_regler">
        <div class="text-danger small mt-1" *ngIf="montantCtrl.invalid && montantCtrl.touched">
          <span *ngIf="montantCtrl.errors?.['required']">Requis</span>
          <span *ngIf="montantCtrl.errors?.['max']">Ne peut pas dépasser {{ itemToSave.reste_a_regler |
            IntegerFormatPipe }} (reste à régler)</span>
        </div>
      </div>
      <div class="col-md-2">
        <label class="form-label">Montant reçu</label>
        <input (input)="onCalculateMonnaie()" class="form-control" name="montant_recu"
          [(ngModel)]="itemToSave.montant_recu" #montant_recuCtrl="ngModel" type="number" required>
        <div class="text-danger small mt-1" *ngIf="montant_recuCtrl.invalid && montant_recuCtrl.touched">Requis</div>
      </div>
      <div class="col-md-2">
        <label class="form-label">Monnaie rendue</label>
        <input disabled class="form-control" name="monnaie_rendue"
          [ngModel]="itemToSave.monnaie_rendue | IntegerFormatPipe" type="text">
      </div>
      <div class="col-md-2">
        <label class="form-label">Référence règlement</label>
        <input class="form-control" name="reference_reglement" [(ngModel)]="itemToSave.reference_reglement"
          #reference_reglementCtrl="ngModel" type="text">
      </div>
    </div>

    <!-- Ligne 3 : Historique -->
    <div class="row">
      <div class="col-12">
        <strong>Historique règlements</strong>
        <div class="table-responsive mt-2" style="max-height: 260px; overflow: auto;">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th># <i class="fa fa-redo ms-1" style="cursor:pointer;" (click)="getItemsReglementHebergement()"></i>
                </th>
                <th>Montant</th>
                <th>Mode règlement</th>
                <th>Caisse</th>
                <th>Montant reçu</th>
                <th>Monnaie rendue</th>
                <th>Mode</th>
                <th>Date</th>
                <th>Option</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of itemsReglementHebergement; let indice = index">
                <td>{{ indice + 1 }}</td>
                <td>{{ item.montant | IntegerFormatPipe }}</td>
                <td>{{ item.mode_reglement_libelle }}</td>
                <td>{{ item.caisse_libelle }}</td>
                <td>{{ item.montant_recu | IntegerFormatPipe }}</td>
                <td>{{ item.monnaie_rendue | IntegerFormatPipe }}</td>
                <td *ngIf="item.is_ristourne" style="color:red;">Ristourne</td>
                <td *ngIf="!item.is_ristourne && !item.is_ristourne_sortie" style="color:green;">Entrée</td>
                <td *ngIf="item.is_ristourne_sortie" style="color:orange;">Ristourne sortie</td>
                <td>{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
                <td><button type="button" class="btn btn-sm btn-primary"
                    (click)="imprimerReglement(item)">Imprimer</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">Fermer</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid"
      *ngIf="!itemToSave.is_sortie || (itemToSave.is_for_contentieux === 1 && itemToSave.reste_a_regler > 0)">Sauvegarder</button>
  </div>
</form>